import styled from 'styled-components';
import Heading from '../Heading';
const H6 = styled(Heading).attrs({
  tagName: 'h6'
}).withConfig({
  displayName: "H6"
})([""]);
H6.displayName = 'H6';
export default H6;